import { type FC, type PropsWithChildren, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";

import { useAuth, useRestoreUrl } from "../hooks/useAuth";

interface RouteProps extends PropsWithChildren {
  fallbackUrl: string;
}

export const PrivateRoute: FC<RouteProps> = ({ children, fallbackUrl }) => {
  const { isLoggedIn } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { store, url, clear } = useRestoreUrl();

  useEffect(() => {
    if (!isLoggedIn && fallbackUrl) {
      store(location);
      navigate(`${fallbackUrl}?${location.search}`);
    }

    if (isLoggedIn && url) {
      const v = url;
      clear();
      navigate(v);
    }
  }, []);

  return <>{children}</>;
};

export const PublicRoute: FC<RouteProps> = ({ children, fallbackUrl }) => {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn && fallbackUrl) return <Navigate to={fallbackUrl} />;

  return <>{children}</>;
};
